<div class="rating-container">
    <div class="star-container" matTooltipPosition="below" [matTooltip]="onEndorsementPage ? '' : toolTipValue[indexOfelement]" [attr.data-title]="onEndorsementPage ? toolTipValue[indexOfelement] : '' " *ngFor="let v of stars;let indexOfelement=index;"
        [ngClass]="{'editable':editable,'not-editable':!editable, 'greyed-out':greyedOut, 'on-endorsement': onEndorsementPage}" (click)="onStarClick(v)">
        <mat-icon [color]="color" [ngStyle]="{color:['primary','accent','warn'].indexOf(color)<0?color:'auto'}">{{v
            <=(skillItem[key]||0)?'star':v==ceil(skillItem[key])?'star_half':'star_border'}} </mat-icon>
    </div>
</div>
